import React from 'react';

import {useMatchMedia} from '@udemy/hooks';
import {LearningTestimonialCard} from '@udemy/react-discovery-units';
import {ContentArea, ContentGrid, ContentGridItem} from '@udemy/react-layout-components';

import styles from './testimonials.module.less';

interface GrowWithGoogleTestimonialsProps {
    title: string;
    testimonials: Array<{
        id: string;
        [key: string]: unknown;
    }>;
}

export const GrowWithGoogleTestimonials = ({
    title,
    testimonials,
}: GrowWithGoogleTestimonialsProps): JSX.Element | null => {
    const isLgMin = useMatchMedia('lg-min');

    if (!testimonials?.length) {
        return null;
    }
    // Note: We need to set the span to 12 for mobile/tablet and 12 / testimonials.length for desktop
    const testimonialsSpan = isLgMin ? 12 / testimonials.length : 12;

    return (
        <div>
            <h2 className={styles['testimonials-heading']}>{title}</h2>

            <ContentArea>
                <ContentGrid className={styles['testimonials-grid']}>
                    {testimonials.map((testimonial) => (
                        <ContentGridItem defaultSpan={testimonialsSpan} key={testimonial.id}>
                            <LearningTestimonialCard
                                className={styles['testimonial-card']}
                                key={testimonial.id}
                                size="large"
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                {...(testimonial as any)}
                            />
                        </ContentGridItem>
                    ))}
                </ContentGrid>
            </ContentArea>
        </div>
    );
};
